import React, { useContext, useState } from 'react';
import {
  arrayOf, bool, number, shape, string, object
} from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Drawer, DrawerItem } from '@thd-olt-component-react/drawer';
import { TileHead } from '../../TileHead';
import { StoreOnlyInfoToolTip } from './StoreOnlyInfoToolTip';
import { StoreOnlyInfoMobileDrawer } from './StoreOnlyInfoMobileDrawer';
import {
  formatInventory, showBopisDate
} from '../../../../helper/utils';

const StoreOnly = ({
  bopisFulfillment, itemId, isShipToHomeEligible, isAppliance, isCartTiles
}) => {
  const { channel } = useContext(ExperienceContext);
  let { storeHours } = useStore();
  storeHours = isCartTiles ? bopisFulfillment?.storeHours : storeHours;
  const localStoreLocation = (bopisFulfillment?.locations || []).find(
    (location) => location.isAnchor
  );
  const quantity = localStoreLocation?.inventory?.quantity;
  const formattedInventoryQty = formatInventory(quantity);
  const [tooltipInstance, setInstance] = useState(null);
  const [isQuickViewOpen, setIsQuickViewOpen] = useState(false);

  const openDrawer = (event) => {
    event.preventDefault();
    setIsQuickViewOpen(true);
  };

  const onAtYourStoreClicked = (event) => {
    if (channel === 'mobile') {
      openDrawer(event);
    } else if (channel === 'desktop') {
      if (tooltipInstance?.hide) {
        tooltipInstance.hide();
      }
    }
  };

  const renderCardDetails = () => {
    return (
      <div role="button" tabIndex={0} className="fulfillment-tile store-only" onClick={onAtYourStoreClicked}>
        <TileHead title="At Your Store" icon="mw-icon-info" />
        <div className="fulfillment__sub-title fulfillment__primary_color">
          {quantity > 0 && (
            <>
              <div className="u__bold">{showBopisDate(storeHours)}</div>
              <div className="fulfillment-qty-row">
                <span className="u__text--success">
                  <span>{formattedInventoryQty}</span>
                </span>
                <span>&nbsp;in stock near you, not eligible for pickup</span>
              </div>
            </>
          )}
          {quantity === 0 && <span>Visit your store to check availability</span>}
        </div>
      </div>
    );
  };

  return channel === 'desktop' ? (
    <Tooltip
      channel={channel}
      closeButton
      placement="bottom"
      distance={-60}
      onShow={(instance) => {
        setInstance(instance);
      }}
      content={<StoreOnlyInfoToolTip />}
      interactive
    >
      <div>{renderCardDetails()}</div>
    </Tooltip>
  ) : (
    <>
      <div>{renderCardDetails()}</div>
      <Drawer
        open={isQuickViewOpen}
        onClose={() => setIsQuickViewOpen(false)}
        initialItem="mobile-quick-view"
        position="bottom"
        maxSize={25}
        isMobile
      >
        <DrawerItem name="mobile-quick-view">
          <StoreOnlyInfoMobileDrawer />
        </DrawerItem>
      </Drawer>
    </>
  );
};
StoreOnly.propTypes = {
  itemId: string.isRequired,
  isShipToHomeEligible: bool,
  isAppliance: bool,
  bopisFulfillment: shape({
    type: string,
    locations: arrayOf(shape({
      isAnchor: bool,
      inventory: shape({
        quantity: number,
        isInStock: bool,
        isLimitedQuantity: bool,
        isBackordered: bool
      })
    }))
  }),
  isCartTiles: bool
};
StoreOnly.defaultProps = {
  isShipToHomeEligible: false,
  isAppliance: false,
  bopisFulfillment: null,
  isCartTiles: false
};

export { StoreOnly };
